import 'babel-polyfill';
import React from 'react';
import { NavLink as RRNavLink, Route, Switch, Redirect } from 'react-router-dom';
import Searchbar from  './Searchbar';
import Home from './Home';
import './App.css';
import { Container, Form, Navbar, NavbarBrand, NavbarToggler, Collapse, Nav, NavItem, NavLink, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarked, faInfoCircle, faSearch, faChartBar, faUserPlus, faTable } from '@fortawesome/free-solid-svg-icons';
import logo from './to2030platform.png';
import lookUpBlockID from './util/lookUpBlockID';
import BenchmarkBuilding from './BenchmarkBuilding';
import Join from './Join';
import About from './About';
import DataDef from './DataDef';

class App extends React.Component {
	
	constructor(props) {
    super(props);
		
    this.toggleNavbar = this.toggleNavbar.bind(this);
		
		this.state = {
			mapCenter: [-79.3817,43.6596],
			mapZoom: [12.8],
			mapBearing: [-16.2],
			blockSelectedID: 1,
			buildingCategory: 'none',
			blockChartShow: false,
			modal: true,
			collapsed: true,
		};
		
		if (window.innerWidth < 991) {
			this.state = {
			mapCenter: [-79.3817,43.6596],
			mapZoom: [12],
			mapBearing: [-16.2],
			blockSelectedID: 1,
			buildingCategory: 'none',
			blockChartShow: false,
			modal: true,
			collapsed: true,
			};
		}
  }
	
	toggleNavbar() {
		if (window.innerWidth < 991) {
			this.setState({
				collapsed: !this.state.collapsed
			});
		}
  }
	
	handleSearchChange = (selected) => {
		this.setState({
			blockDetails: selected,
			blockSelectedID: selected[0].blockid,
			mapCenter: [selected[0].longitude, selected[0].latitude],
			mapZoom: [15],
			mapPitch: [35],
			blockChartShow: true,
		});
		if(window.innerWidth < 991) {
			this.setState({
				collapsed: !this.state.collapsed
			});
		}
	}
	
	handleBuildingCategoryChange = (elems) => {
		this.setState({
			buildingCategory: elems,
			mapCenter: [-79.3817,43.6596],			
			mapZoom: [12.8],			
		});
		if (window.innerWidth < 991) {
			this.setState({			
				mapZoom: [12],	
			})
		};
	}


	handleMapClick = (map,e) => {
		const clickFeatures = map.queryRenderedFeatures(e.point);
		
		if (!clickFeatures.length || typeof clickFeatures[0].properties.BLOCKID === 'undefined') {
			this.setState({
					blockSelectedID: 1,
					blockDetails: '',
					blockChartShow: false,
					buildingCategory: 'none'
			})
      return;
    }
		
		this.setState({
			blockSelectedID: clickFeatures[0].properties.BLOCKID,
			mapCenter: e.lngLat,
			mapZoom: [15],
			mapPitch: [35],
			blockChartShow: true,
			buildingCategory: 'none'
		})
		
		const lookupID = this.state.blockSelectedID;
		lookUpBlockID(lookupID)
			.then(({retrieved}) => {
				this.setState({
					isLoading: true,
					blockDetails: retrieved})
		});
	}
		
	handleMapZoomEnd = (map,e) => {
		this.setState({
			mapZoom: [...[map.getZoom()]]
		})
		if ( map.getZoom() < 13.5) {		
			this.setState({
				mapPitch: [0],
				blockChartShow: false,
				blockSelectedID: 1,
			})
			return;
		}
	}
	
	zoomOut = () => {
		this.setState({
			mapCenter: [-79.3817,43.6596],
			mapZoom: [12.8],
			mapBearing: [-16.2],
			mapPitch: [0],
			blockSelectedID: 1,
			buildingCategory: 'none',
			blockChartShow: false,
		})
		if(window.innerWidth < 991) {
			this.setState({
				mapZoom: [12],
			});
		}		
	}
	
  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }
	
  render() {
		
    return (
		
			<Container fluid className='w-100 h-100 d-flex flex-column'>
				<Navbar color='dark' dark expand='lg' className='pl-0'>
					<NavbarBrand href='/'>
							<img src={logo} className='App-logo ml-4' alt='logo' />
					</NavbarBrand>
					<NavbarToggler onClick={this.toggleNavbar} />
					<Collapse isOpen={!this.state.collapsed} navbar>
							<Nav className='mr-auto' navbar onClick={this.toggleNavbar}>
								<NavItem>
									<NavLink exact tag={RRNavLink} to='/' className='px-3 text-center' activeClassName='active'><FontAwesomeIcon icon={faMapMarked} size='lg' />District Map</NavLink>
								</NavItem>							
								<NavItem>
									<NavLink tag={RRNavLink} to='/benchmark-your-building' className='px-3 text-center' activeClassName='active'><FontAwesomeIcon icon={faChartBar} size='lg' />  &nbsp;Benchmark Your Building</NavLink>
								</NavItem>
								<NavItem>
									<NavLink tag={RRNavLink} to='/join' className='px-3 text-center'><FontAwesomeIcon icon={faUserPlus} size='lg' />Join the 2030 District</NavLink>
								</NavItem>
								<NavItem>
									<NavLink tag={RRNavLink} to='/about' className='px-3 text-center' activeClassName='active'><FontAwesomeIcon icon={faInfoCircle} size='lg' />About</NavLink>
								</NavItem>								
								<NavItem>
									<NavLink tag={RRNavLink} to='/data-and-definitions' className='px-3 text-center'><FontAwesomeIcon icon={faTable} size='lg' />Data & Definitions</NavLink>
								</NavItem>
							</Nav>
						<Form className='Searchbar input-group pl-3'>
							<Searchbar onSearchChange={this.handleSearchChange} />		
							<div className='input-group-append search-icon'>
								<span className='input-group-text'><FontAwesomeIcon icon={faSearch} size='md' /></span>
							</div>
						</Form>							
					</Collapse>
				</Navbar>
				<Switch>
					<Route exact path='/' render={(props) => (
						<div className='home'>
							<Home {...props}
								onMapClick = {this.handleMapClick}
								onMapZoomEnd = {this.handleMapZoomEnd}
								onBuildingCategoryChange = {this.handleBuildingCategoryChange}
								mapCenter = {this.state.mapCenter} 
								mapZoom = {this.state.mapZoom} 
								zoomOut = {this.zoomOut}
								mapPitch = {this.state.mapPitch}
								mapBearing = {this.state.mapBearing} 
								blockSelectedID = {this.state.blockSelectedID}
								blockDetails = {this.state.blockDetails}
								blockChartShow = {this.state.blockChartShow}
								buildingCategory = {this.state.buildingCategory}
							/>
					</div>
					)} />
					<Route path='/benchmark-your-building' component={BenchmarkBuilding} />
					<Route path='/join' component={Join} />				
					<Route path='/about' component={About} />
					<Route path='/data-and-definitions' component={DataDef} />
					<Route render={() => <Redirect to="/" />} />
					</Switch>
			</Container>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js